import { generalConstants } from '@tweddle-se-team/common/constants'
import { groupBy as R_groupBy, uniq as R_uniq } from 'ramda'
import apiWrapper from './apiWrapper'

const { tagsByContentType } = generalConstants

const getFiltersMatcher = filters => {
  const entries = Object.entries(filters)
  return product => entries.every(([key, value]) => product[key] === value || !value)
}

const getProductsFilteredBy = (products = [], filters = {}) => products.filter(getFiltersMatcher(filters)) || {}

const getUniqueProductsGroupedByModel = products => {
  const productsWithUniqueModelType = products.reduce((result, product) => {
    if (!result.find(({ modelType }) => modelType === product.modelType)) result.push(product)
    return result
  }, [])
  return R_groupBy(({ model }) => model, productsWithUniqueModelType)
}

const getUniqueProductsGroupedByModelType = products => {
  const productsWithUniqueModelType = products.reduce((result, product) => {
    if (!result.find(({ modelType, year }) => modelType === product.modelType && year === product.year))
      result.push(product)
    return result
  }, [])
  return R_groupBy(({ modelType }) => modelType, productsWithUniqueModelType)
}

const getModelsByBrand = (products = [], brand) =>
  R_uniq(getProductsFilteredBy(products, { brand }).map(({ model }) => model))

const getModelTypesByModelOrBrand = (products = [], model, brand) =>
  R_uniq(getProductsFilteredBy(products, { model, brand }).map(({ modelType }) => modelType))

const getLineOffDateByCriteria = (products = [], { brand, model, modelType }) =>
  R_uniq(getProductsFilteredBy(products, { modelType, model, brand }).map(({ lineOffDate }) => lineOffDate)).filter(
    lineOffDate => lineOffDate
  )

const findFirstMatching = (products = [], filters = {}) => products.find(getFiltersMatcher(filters)) || {}

const getLocales = () => apiWrapper.get('pubhub/info/locales', {}) || []

const getProducts = query => apiWrapper.get('pubhub/info/products', { ...query }) || []

const getMetadataTags = async () => {
  const pdfTags = Object.values(tagsByContentType)
  // Filtering out all tags regarding pdf documents
  return ((await apiWrapper.get('pubhub/info/tags', {})) || []).filter(tag => !pdfTags.find(pdf => pdf === tag)).sort()
}

const getPublication = async id => await apiWrapper.get(`pubhub/publications/${id}`)

const getPublicationContentById = async id => await apiWrapper.get(`pubhub/publications/${id}/content`)

const getPublicationTextSearch = async (id, filters) =>
  await apiWrapper.get(`pubhub/publications/${id}/text-search`, filters)

const pubhubData = {
  getProducts,
  getUniqueProductsGroupedByModel,
  getModelsByBrand,
  getModelTypesByModelOrBrand,
  getPublication,
  getPublicationContentById,
  getPublicationTextSearch,
  getLocales,
  getMetadataTags,
  getUniqueProductsGroupedByModelType
}

export default pubhubData
